import { inject, Injectable } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  FormControl,
} from '@angular/forms';
import {
  ICaptchaRadicadoForm,
  IConsultaCaptchaForm,
  IConsultaIdentificacionForm,
  IConsultaRadicadoForm,
} from '../interfaces/consulta-externa-pqrs.interface';

@Injectable({
  providedIn: 'root',
})
export class FormBuilderService {
  private fb = inject(FormBuilder);
  formIdentificacion!: FormGroup<IConsultaIdentificacionForm>;
  formConsultaRadicado!: FormGroup<IConsultaRadicadoForm>;
  formcaptcha!: FormGroup<IConsultaCaptchaForm>;
  formcaptchaRadicado!: FormGroup<ICaptchaRadicadoForm>;

  buildFormConsultaIdentificacionPqr(): FormGroup<IConsultaIdentificacionForm> {
    this.formIdentificacion = this.fb.group<IConsultaIdentificacionForm>({
      Identificacion: this.createControl<string | null>(null),
    });

    return this.formIdentificacion;
  }
  buildFormConsultaRadicadoPqr(): FormGroup<IConsultaRadicadoForm> {
    this.formConsultaRadicado = this.fb.group<IConsultaRadicadoForm>({
      CodRadicado: this.createControl<string | null>(null),
    });

    return this.formConsultaRadicado;
  }
  buildFormcaptchaRadicado(): FormGroup<ICaptchaRadicadoForm> {
    this.formcaptchaRadicado = this.fb.group<ICaptchaRadicadoForm>({
      UserInputt: this.createControl<string | null>(null),
      token: this.createControl<string | null>(null),
    });

    return this.formcaptchaRadicado;
  }
  buildFormcaptcha(): FormGroup<IConsultaCaptchaForm> {
    this.formcaptcha = this.fb.group<IConsultaCaptchaForm>({
      UserInput: this.createControl<string | null>(null),
      token: this.createControl<string | null>(null),
    });

    return this.formcaptcha;
  }
  /**
   *
   * @param value
   * @param validators
   * @returns
   * @augments OJO => No modificar
   */
  private createControl<T>(
    value: T | { value: T | null; disabled: boolean } | null,
    validators?: ValidatorFn | ValidatorFn[] | null,
  ): FormControl<T | null> {
    return this.fb.control(value, validators);
  }
}
